module.exports = __webpack_public_path__ + "static/media/trash.0d10f8f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trash.svg
// module id = 2028
// module chunks = 32